import { useState, useRef } from "react";

export interface UseTagsReturn {
  tagInput: {
    value: string;
    update: (value: string) => void;
    clear: () => void;
  };
  tags: {
    list: string[];
    add: () => void;
    remove: (tag: string) => void;
    reset: () => void;
  };
}

export function useTags(initialTags: string[] = []): UseTagsReturn {
  const initialRef = useRef(initialTags); // avoid stale resets

  const [tagInput, setInput] = useState("");
  const [tags, setTags] = useState<string[]>(initialTags);

  const updateInput = (value: string) => {
    setInput(value);
  };

  const clearInput = () => {
    setInput("");
  };

  const addTag = () => {
    const tag = tagInput.trim();

    if (tag.length === 0) {
      clearInput();
      return;
    }

    const exists = tags.some(
      (t) => t.toLowerCase() === tag.toLowerCase()
    );

    if (exists) {
      clearInput();
      return;
    }

    setTags((current) => [...current, tag]);
    clearInput();
  };

  const removeTag = (tag: string) => {
    setTags((current) =>
      current.filter((item) => item !== tag)
    );
  };

  const resetTags = () => {
    clearInput();
    setTags(initialRef.current);
  };

  return {
    tagInput: {
      value: tagInput,
      update: updateInput,
      clear: clearInput,
    },
    tags: {
      list: tags,
      add: addTag,
      remove: removeTag,
      reset: resetTags,
    },
  };
}